import { render, staticRenderFns } from "./social-media.vue?vue&type=template&id=42411054&scoped=true&"
import script from "./social-media.vue?vue&type=script&lang=js&"
export * from "./social-media.vue?vue&type=script&lang=js&"
import style0 from "./social-media.vue?vue&type=style&index=0&id=42411054&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42411054",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
